<template>
    <b-container fluid>
        <b-row>
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">Dashboard</h4>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loading">
                            <div class="message-body-center">
                                <template v-if="isProfileComplete">
                                    <b-row class="mt-3">
                                        <b-col md="12">
                                            <iq-card>
                                                <template v-slot:body>
                                                    <b-row>
                                                        <b-col cols="4" class="custom-box-shadow">
                                                            <div class="bg-success p-3 rounded mb-3 text-center">
                                                                <h5 class="text-white d-block">
                                                                    {{ $t('externalUser.total_applicant')}}
                                                                </h5>
                                                                <b-spinner v-if="unitLoad" variant="primary" label="Spinning"></b-spinner>
                                                                <h2 v-else class="text-white">{{ $n(datas.totalApplicant[0].totalApplicant) }}</h2>
                                                            </div>
                                                        </b-col>
                                                        <b-col cols="4" class="custom-box-shadow">
                                                            <div class="bg-success p-3 rounded mb-3 text-center">
                                                                <h5 class="text-white d-block">
                                                                    {{ $t('externalUser.sorted_applicant')}}
                                                                </h5>
                                                                <b-spinner v-if="unitLoad" variant="primary" label="Spinning"></b-spinner>
                                                                <h2 v-else class="text-white">{{ $n(datas.sortedApplicant[0].sortedApplicant) }}</h2>
                                                            </div>
                                                        </b-col>
                                                        <b-col cols="4" class="custom-box-shadow">
                                                            <div class="bg-success p-3 rounded mb-3 text-center">
                                                                <h5 class="text-white d-block">
                                                                    {{ $t('externalUser.confirmed_applicant')}}
                                                                </h5>
                                                                <b-spinner v-if="unitLoad" variant="primary" label="Spinning"></b-spinner>
                                                                <h2 v-else class="text-white">{{ $n(datas.confirmedApplicant[0].confirmedApplicant) }}</h2>
                                                            </div>
                                                        </b-col>
                                                    </b-row>
                                                </template>
                                            </iq-card>
                                        </b-col>
                                    </b-row>
                                </template>
                                <p class="pb-2 pt-2 h5" v-else>
                                    <span class="text-danger"><i class="ri-alert-fill mr-2"></i> Before fillout this form, please complete your</span>
                                    <a href="/employer-panel/profile-edit" class=""> Profile </a>
                                </p>
                            </div>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
    import { profile, employerdashboardApi } from '../api/routes'
    import { mapGetters } from 'vuex'

    export default {
        data () {
            return {
                loading: false,
                unitLoad: false,
                isProfileComplete: 0
            }
        },
        created () {
            this.userProfileCheck()
            this.getDashboard()
        },
        computed: {
            ...mapGetters({
                panelObj: 'ExternalUser/panelObj'
            })
        },
        methods: {
            async userProfileCheck () {
                this.loading = true
                const result = await RestApi.getData(awarenessEventServiceBaseUrl, profile)
                this.loading = false
                if (result.success) {
                    this.isProfileComplete = 1
                } else {
                    this.isProfileComplete = 0
                }
            },
            async getDashboard () {
                this.unitLoad = true
                const result = await RestApi.getData(awarenessEventServiceBaseUrl, employerdashboardApi)
                if (result.success) {
                    this.datas = result.data
                } else {
                    this.datas = []
                }
                this.unitLoad = false
            }
        }
    }
</script>
